import { Injectable, signal } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MetaTitleService extends TitleStrategy {
  private readonly _pageTitle = signal<string>('');
  public readonly pageTitle = this._pageTitle.asReadonly();

  // Routes set their title under data.meta.title (not Angular's native `title`),
  // so we resolve it from the snapshot instead of buildTitle(). MetaService owns
  // the document <title>; here we only maintain the in-app page title signal.
  override updateTitle(snapshot: RouterStateSnapshot): void {
    this._pageTitle.set(this.resolveMetaTitle(snapshot) ?? '');
  }

  private resolveMetaTitle(snapshot: RouterStateSnapshot): string | undefined {
    let route: ActivatedRouteSnapshot | null = snapshot.root;
    let title: string | undefined;
    while (route) {
      if (route.outlet === 'primary' && route.data?.['meta']?.['title']) {
        title = route.data['meta']['title'];
      }
      route = route.firstChild;
    }
    return title;
  }
}
